import { OverlaySpinner } from '@ankr.com/ui';

import { useRequestsChartSkeletonStyles } from './useRequestsChartSkeletonStyles';

export const RequestsChartSkeleton = () => {
  const { classes } = useRequestsChartSkeletonStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <OverlaySpinner />
      </div>
    </div>
  );
};
